// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { discountTypes } from '../../../../../../../../config/types';

import styles from './styles.js';

const MainRightInfo = ({ classes, order }) => {
  const currency = '£ ';
  const discount_description = 'DICOUNT - ';
  const amount_description = 'ORDER AMOUNT - ';
  const paid_description = 'AMOUNT PAID - ';
  const accepted_value_description = 'ACCEPTED VALUE - ';
  const rejected_value_description = 'REJECTED VALUE - ';

  const discountTextGenerate = (discountCode) => {
    const type = discountCode ? discountCode.DiscountType : 0;
    switch (type) {
      case 1:
        return `${discountCode.Value}${discountTypes[discountCode.DiscountType]}`;
      case 2:
        return `${discountTypes[discountCode.DiscountType]}${discountCode.Value}`;
      default:
        return 'No discount code';
    }
  };

  return (
    <div className={classes.mainInfoContainer}>
      <span>
        {amount_description}
        <span className={classes.boldFont}>
          {`${currency}${order.OrderValue.toFixed(2)}`}
        </span>
      </span>
      <span>
        {discount_description}
        <span className={classes.boldFont}>
          {`${discountTextGenerate(order.DiscountCode)}`}
        </span>
      </span>
      <span>
        {paid_description}
        <span className={classes.boldFont}>
          {`${currency}${order.AmountPaid.toFixed(2)}`}
        </span>
      </span>
      <span>
        {accepted_value_description}
        <span className={classes.boldFont}>
          {`${currency}${order.AcceptedValue.toFixed(2)}`}
        </span>
      </span>
      <span>
        {rejected_value_description}
        <span className={classes.boldFont}>
          {`${currency}${order.RejectedValue.toFixed(2)}`}
        </span>
      </span>
    </div>
  );
};

MainRightInfo.propTypes = {
  classes: PropTypes.object,
  order: PropTypes.object.isRequired,
};

MainRightInfo.defaultProps = {
  classes: {},
};

export default withStyles(styles)(MainRightInfo);
